var _defs;
import * as React from "react";
import { forwardRef } from "react";
const SvgDefinitions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m 1024,161 v 190 q 0,14 -9.5,23.5 Q 1005,384 992,384 H 800 q -13,0 -22.5,-9.5 Q 768,365 768,351 V 161     q 0,-14 9.5,-23.5 Q 787,128 800,128 h 192 q 13,0 22.5,9.5 9.5,9.5 9.5,23.5 z m -2,374 18,459 q 0,12 -10,19 -13,11 -24,11     H 786 q -11,0 -24,-11 -10,-7 -10,-21 l 17,-457 q 0,-10 10,-16.5 10,-6.5 24,-6.5 h 185 q 14,0 23.5,6.5 9.5,6.5 10.5,16.5     z m -14,934 768,-1408 q 35,-63 -2,-126 -17,-29 -46.5,-46 -29.5,-17 -63.5,-17 H 128 q -34,0 -63.5,17     Q 35,-94 18,-65 -19,-2 16,61 l 768,1408 q 17,31 47,49 30,18 65,18 35,0 65,-18 30,-18 47,-49 z",
    id: "warning-sign"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0-10C12.95 4 4 12.95 4 24s8.95 20 20 20     20-8.95 20-20S35.05 4 24 4zm0 36c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z",
    id: "target"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefinitions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/definitions.e5a357d0ed8be22ab5b4ad710a435476.svg";